// core
import React from 'react';
import { useState } from 'react';

import
{
    createBrowserRouter,
    RouterProvider
} from "react-router-dom";

import SiteRoot from 'components/layout/root';
// route conf
import conf from 'conf/ajax';

// components
import QuestionsList from 'components/questions/questions_list';
import QuestionAndAnswers from 'components/questions/question_and_answers'
import QATags from 'components/tags/qa_tags';
import AskPanel from 'components/pages/ask_panel';
import NotFound from 'components/commons/404';
import UserPanel from 'components/user_page/user_page';
import QABasicRules from 'components/pages/rules'
import QARoot from 'components/commons/qa_root';
import NotificationPanel from 'components/pages/notification';

// state
import { StateContext } from 'store/state_context';
import AjaxSpinner from './commons/ajax_spinner';

export default function Main(props)
{
    // This will run one time after the component mounts
    const GlobalStateManagement = (props) =>
    {
        const [total_questions, set_total_questions] = useState(0);
        return (
            <StateContext.Provider value={{total_questions, set_total_questions}}>
                {props.children}
            </StateContext.Provider>
        );

    };

    const flat_route = (route) => route.replace(conf.route.base, '');

    const router = createBrowserRouter([
        {
            path: conf.route.base,
            element: <SiteRoot />,
            errorElement: <NotFound />,
            children: [
                {
                    path: flat_route(conf.route.answer),
                    element: <QuestionsList />
                },
                {
                    path: flat_route(conf.route.ask),
                    element: <AskPanel />
                },
                {
                    path: flat_route(conf.route.rules),
                    element: <QABasicRules />
                },
                {
                    path: flat_route(conf.route.root),
                    element: <QARoot />
                },
                {
                    path: flat_route(conf.route.answers),
                    element: <QuestionAndAnswers />
                },
                {
                    path: flat_route(conf.route.notification),
                    element: <NotificationPanel />
                },
                {
                    path: flat_route(conf.route.user),
                    element: <UserPanel />
                },
                {
                    path: flat_route(conf.route.tags),
                    element: <QATags />
                },
                {
                    path: flat_route(conf.route.page_not_found),
                    element: <NotFound />
                },
                {
                    path: '*',
                    element: <NotFound />
                }
            ]
        }
    ]);
    return (
        <GlobalStateManagement>
            <main className="container">
                <RouterProvider router={router}
                    errorElement={<NotFound/>}
                    fallbackElement={<AjaxSpinner />}
                />
            </main>
        </GlobalStateManagement>
    );
};